var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdditionalDescription',{attrs:{"entity-type":_vm.BUSINESS_TYPE.ENTITY,"entity-id":+_vm.$route.params.id},scopedSlots:_vm._u([{key:"tabs",fn:function(){return [_c('EntityTabLinks')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }